import React from 'react';
import logo from '../img/logo.webp';
export function Footer() {
    const scrollToSection = (id) => {
        document.getElementById(id)?.scrollIntoView({
            behavior: "smooth",
            block: "start",
        });
    };
    return (
        <>
            <footer>
                <div className="wrap">
                    <div className="f-top">

                        <a className="logo" href="#"><span className="a">HOME
                        </span><span className="b">2</span>
                            <span className="c">OUTDOOR</span>
                        </a>
                        <p className="f-tag">Australian brand distribution.<br />Home to outdoor - and beyond.</p>
                        <div className="f-nav">
                            <a href="/model" onClick={(e) => { e.preventDefault(); scrollToSection("model"); }}>
                                Model
                            </a>

                            <a href="/channels" onClick={(e) => { e.preventDefault(); scrollToSection("channels"); }}>
                                Channels
                            </a>

                            <a href="/brands" onClick={(e) => { e.preventDefault(); scrollToSection("program"); }}>
                                Brands
                            </a>

                            <a href="/contact" onClick={(e) => { e.preventDefault(); scrollToSection("partner"); }} >
                                Contact
                            </a>
                        </div>
                    </div>
                    <div className="powered">
                        <span className="mono">Powered by</span>
                        <img src={logo} alt="Ship2Anywhere" />
                        {/* <span className="s2a">Ship<i>2</i>Anywhere</span> */}
                    </div>
                    <div className="legal">
                        <span>© 2026 Home2Outdoor</span>
                        <span>A subsidiary of Ship2Anywhere</span>
                        <span>Brisbane, QLD, Australia · +61 3 9012 3456</span>
                        <span>Duracell is a trademark of its respective owner</span>
                    </div>
                </div>
            </footer>
        </>
    )
}